import { toast } from "sonner";
import type { BriefTranslations } from "@/lib/i18n/types/brief";
import { errorHint } from "../repository";

/**
 * One place that turns a brief RPC failure into a toast: the hints the RPCs
 * raise (`brief_empty`, `brief_nothing_changed`, `brief_version_gone`) map to the page's copy,
 * anything else shows the server's own message, and a message-less failure
 * shows the fallback.
 */
export function toastBriefError(copy: BriefTranslations, error: unknown, fallback: string): void {
  const hint = errorHint(error);
  if (hint === "brief_empty") {
    toast.error(copy.run.emptyBrief);
    return;
  }
  if (hint === "brief_nothing_changed") {
    toast.error(copy.confirm.nothingChanged);
    return;
  }
  if (hint === "brief_version_gone") {
    toast.error(copy.versions.gone);
    return;
  }
  toast.error(error instanceof Error && error.message ? error.message : fallback);
}
